import { clsx } from 'clsx';

interface EntityBadgeProps {
  type: 'business' | 'trainer';
}

export function EntityBadge({ type }: EntityBadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center w-8 h-8 rounded-lg text-sm font-bold',
        type === 'business'
          ? 'bg-blue-100 text-blue-700'
          : 'bg-emerald-100 text-emerald-700',
      )}
    >
      {type === 'business' ? 'B' : 'T'}
    </span>
  );
}
